import React from 'react';
import {useRegistryProject} from '../RegistryProjectContext';
import {KnowledgeManagerPageRegistry} from './KnowledgeManagerPageRegistry';

export const RegistryKnowledgeManagerPage = () => {
  const {project, subProject} = useRegistryProject();
  return <KnowledgeManagerPageRegistry project={project} subProject={subProject}/>;
};
